var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhilippines2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "philippines@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-747.000000, -315.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "philippines"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(677.000000, 245.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.89,0.12 L6.61,0.12 C3.09746899,0.12 0.25,2.96746899 0.25,6.48 L0.25,24.12 L70.25,24.12 L70.25,6.48 C70.25,2.96746899 67.402531,0.12 63.89,0.12 Z",
    id: "Shape",
    fill: "#4758A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25,40.75 C0.25,44.262531 3.09746899,47.11 6.61,47.11 L63.88,47.11 C65.5667769,47.11 67.1844678,46.4399305 68.3771991,45.2471991 C69.5699305,44.0544678 70.24,42.4367769 70.24,40.75 L70.24,24.12 L0.24,24.12 L0.25,40.75 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15,1.95 C0.931164836,3.14574529 0.246154249,4.78256006 0.25,6.49 L0.25,40.76 C0.251149023,42.4851958 0.955294766,44.1354245 2.2,45.33 L25.25,24.12 L2.15,1.95 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3_copy_2-4",
    fill: "#F6D660",
    cx: 10.25,
    cy: 23.62,
    r: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines2X);
export default __webpack_public_path__ + "static/media/philippines@2x.2a97e76e26b200d439bbe26e51df9a89.svg";
export { ForwardRef as ReactComponent };